export enum Role {
    Organizer = 'organizador',
    Producer = 'productor_asesor',
    Linker = 'broker',
}